import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Alert, Modal } from 'antd';
import { actions, selectors, useCanAddIndividualMeters } from './model';
import Step, { useStepTitle } from './components/presenters/Step';
import { useNavigationBlocker } from '../../../../hooks/useNavigationBlocker';
import { links } from '../../constants/links';
import styles from './ImportsPage.module.scss';

const { companyChangeAction, resetStateAction } = actions;
const { selectCompanyId, selectIsNavigationBlocked } = selectors;

const NavigationBlocker = ({ children }) => {
  const isBlocked = useSelector(selectIsNavigationBlocked);

  const dispatch = useDispatch();

  useNavigationBlocker(isBlocked, ({ location, unblock, history }) => {
    const path = location.pathname;

    if (
      path.startsWith(links.rootWithCompany) &&
      path.endsWith(links.imports)
    ) {
      unblock();
      history.push(location);
      return;
    }

    Modal.confirm({
      title: 'Вы уверены, что хотите покинуть страницу "Импорт" ?',
      content: 'Введенные данные будут потеряны.',
      okText: 'Да',
      cancelText: 'Нет',
      onOk: () => {
        unblock();
        dispatch(resetStateAction());
        history.push(location);
      },
      onCancel: () => {},
    });
  });

  return children;
};

const Wrapper = ({ children }) => {
  const companyId = useSelector(selectCompanyId);
  const dispatch = useDispatch();
  const isFirstRenderRef = useRef(true);

  useEffect(() => {
    if (isFirstRenderRef.current) {
      isFirstRenderRef.current = false;
      return;
    }
    dispatch(companyChangeAction());
  }, [companyId, dispatch]);

  useEffect(() => {
    return () => dispatch(resetStateAction());
  }, [dispatch]);

  return children;
};

const createTitle = (canAddIndividualMeters) => {
  const items = [
    'собственников',
    'лицевых счетов',
    canAddIndividualMeters && 'ИПУ',
  ].filter(Boolean);

  const lastItem = items.pop();
  return `${items.join(', ')} и ${lastItem}`;
};

const renderTitle = (title) => (
  <span className={styles.alertMessage}>{title}</span>
);

const PageAlert = () => {
  const canAddIndividualMeters = useCanAddIndividualMeters();
  const stepTitle = useStepTitle();
  const title = createTitle(canAddIndividualMeters);

  return (
    <Alert
      type="info"
      message={renderTitle(stepTitle || `Импорт ${title}`)}
    />
  );
};

const ImportsPage = () => {
  return (
    <NavigationBlocker>
      <Wrapper>
        <div className={styles.root}>
          <PageAlert />
          <Step className={styles.step} />
        </div>
      </Wrapper>
    </NavigationBlocker>
  );
};

export default ImportsPage;
